import { createAction, createSlice } from "@reduxjs/toolkit";

const addBalanceSlice = createSlice({
  name: "addBalance",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state, action) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state, action) {
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state, action) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = addBalanceSlice;
const addBalanceAction = createAction(name);

export {
  addBalanceAction,
  actions as addBalanceActions,
  reducer as addBalanceReducer,
};
